module.exports = "<a role=\"button\"\r\n   ng-click=\"$ctrl.showDialog()\"\r\n   href=\"\"\r\n   translate>\r\n  Terms of Use\r\n</a>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/modules/utils/rw-terms-of-use/rw-terms-of-use.html
// module id = 1962
// module chunks = 0